import { render, staticRenderFns } from "./OnboardingApp.vue?vue&type=template&id=401100db"
import script from "./OnboardingApp.vue?vue&type=script&lang=js"
export * from "./OnboardingApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports